import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { CarouselModule } from 'primeng/carousel';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';


@NgModule({
  imports: [
    TableModule,
    InputTextModule,
    InputNumberModule,
    InputMaskModule,
    TooltipModule,
    CarouselModule,
    DialogModule,
    TabViewModule,
    CalendarModule,
    InputSwitchModule,
    DropdownModule,
    RadioButtonModule,
    ButtonModule,
    CheckboxModule
  ],
  exports: [
    TableModule,
    InputTextModule,
    InputNumberModule,
    InputMaskModule,
    TooltipModule,
    CarouselModule,
    DialogModule,
    TabViewModule,
    CalendarModule,
    InputSwitchModule,
    DropdownModule,
    RadioButtonModule,
    ButtonModule,
    CheckboxModule
  ],
  declarations: []
})
export class PrimngModule { }
